<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Logs de Operadores (Clientes) - Em desenvolvimento...</h5>
                <hr> 
                <div class="p-d-flex p-jc-start p-mt-4">
                    <Button label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" @click="voltar" />
                </div>
            </div>           
        </div>
    </div>
</template>

<script>
    export default {
        props: {       
            idConta: { type: [String, Number], default: null }
        },
        methods: {
            voltar() {
                this.$router.go(-1);
            }
        }
    }
</script>
<style scoped>
</style>
